import axios from 'axios';


import server from '../ServerUrl'

const getToken = () => localStorage.getItem('token');
const apiBaseUrl = server.server

// POST request handler 
const handleRequest = async (endpoint, formData, navigate = null) => {
    const token = getToken();

    if (!token) {
        return 'No authentication token found.';
    }

    try {
        const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        console.error(error);
        if (error.message === 'Network Error' && navigate) {
            navigate('/');
            return 'Error: Network Error - Redirecting to home';
        }
        if (error.response) {
            return `Error: ${error.response.data.message || 'Request Failed'}`;
        } else {
            return 'Network error. Please try again.';
        }
    }
};

// GET request handler
const handleGetRequest = async (endpoint, navigate = null) => {
    const token = getToken();

    if (!token) {
        return 'No authentication token found.';
    }

    try {
        const response = await axios.get(`${apiBaseUrl}/${endpoint}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        if (error.message === 'Network Error' && navigate) {
            navigate('/');
            return 'Error: Network Error - Redirecting to home';
        } console.error(error);
        if (error.response) {
            return `Error: ${error.response.data.message || 'Request Failed'}`;
        } else {
            return 'Network error. Please try again.';
        }
    }
};
const handleFileUpload = async (endpoint, formData, navigate = null) => {
    const token = getToken();
    const maxFileSizeBytes = 10 * 1024 * 1024;
    const selectedFile = formData?.get?.('image');

    if (selectedFile && selectedFile.size > maxFileSizeBytes) {
        throw new Error('File size must be 10MB or less.');
    }

    if (!token) {
        throw new Error('No authentication token found.');
    }

    const getSectionFromUrl = () => {
        const hash = window.location.hash || '';
        if (hash.includes('/requestProperty')) return 'Dcp/form_documents';
        if (hash.includes('/reqProperty')) return 'Dcp/chat_documents';
        if (hash.includes('/soc')) return 'soc';
        if (hash.includes('/kyp')) return 'kyp/form_documents';
        if (hash.includes('/KYPList')) return 'kyp/landuse_document';
        const path = window.location.pathname || '';
        if (path.includes('requestProperty')) return 'Dcp/form_documents';
        if (path.includes('reqProperty')) return 'Dcp/chat_documents';
        if (path.includes('soc')) return 'soc';
        if (path.includes('kyp')) return 'kyp/form_documents';
        if (path.includes('KYPList')) return 'kyp/landuse_document';
        return 'Dcp/form_documents';
    };
    const section = getSectionFromUrl();
    try {
        const response = await axios.post(`${apiBaseUrl}/${endpoint}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-docity-section': section,
            },
        });
        return response.data;
    } catch (error) {
        console.error(error);

        if (error.message === 'Network Error') {
            if (navigate) {
                navigate('/');
            }
            throw new Error('Network Error - Redirecting to home');
        }

        if (error.response) {
            const message = error.response.data?.message || 'File upload failed';
            throw new Error(message);
        }

        throw new Error('Network error. Please try again.');
    }
};

const PropertiesService = {
    getPropertyData: () => handleGetRequest('getAllProperties'),
    editCivilEngineer: (formData) => handleRequest('editCivilEngData', formData),
    UploadFiles: (formData) => handleFileUpload('MultipleFileUpload', formData),
    getCivilEngineer: (formData) => handleRequest('getCivilEngData', formData),
    getCivilEngineerProperties: (formData) => handleRequest('getCivilEngineerAssignedProperties', formData),
    getQuestions: () => handleGetRequest('getQuestions'),
    getDocs: (formData) => handleRequest('getDocs', formData),
    findChat: (formData) => handleRequest('findChat', formData),
    getMessagesWithChatId: (formData) => handleRequest('getMessagesWithChatId', formData),
    createChat: (formData) => handleRequest('createChat', formData),
    createMessage: (formData) => handleRequest('createMessage', formData),
    getAssignedProperties: (formData) => handleRequest('getUsersAssignedToCivilEngineer', formData),
    getSignleProperty: (formData) => handleRequest('getSignleProperty', formData),
    getAllCivilEngs: () => handleGetRequest('getAllCivilEngs'),
    getdoCityUsers: () => handleGetRequest('getAllDoCityUsers'),
    generateAadharOtp: (formData, navigate) => handleRequest('generateAadharOtp', formData, navigate),
    validateAadharOtp: (formData, navigate) => handleRequest('validateAadharOtp', formData, navigate),
    updateProperty: (formData, navigate) => handleRequest('updateProperty', formData, navigate),
    UpdateDocument: (formData, navigate) => handleRequest('UpdateDocument', formData, navigate),
    updateMessage: (formData, navigate) => handleRequest('updateMessage', formData, navigate),
    getMessages: (formData, navigate) => handleRequest('getMessages', formData, navigate),

};

export default PropertiesService;
